export interface ClientSessionData {
  clientId: string;
  nombre: string;
  telefono: string;
  timestamp: number;
}

const STORAGE_KEY = "ciencuadras_client_session";
const COOKIE_KEY = "ciencuadras_client_id";
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

function setCookie(name: string, value: string, days: number = 7) {
  try {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  } catch (e) {
    console.warn("Failed to set cookie:", e);
  }
}

function getCookie(name: string): string | null {
  try {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : null;
  } catch (e) {
    return null;
  }
}

export function saveClientSession(data: { clientId: string; nombre: string; telefono: string }): void {
  const session: ClientSessionData = {
    ...data,
    timestamp: Date.now(),
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    setCookie(COOKIE_KEY, JSON.stringify(session), 7);
  } catch (err) {
    console.error("Error saving client session:", err);
  }
}

export function getClientSession(): ClientSessionData | null {
  try {
    let raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      raw = getCookie(COOKIE_KEY);
    }
    if (!raw) return null;

    const data: ClientSessionData = JSON.parse(raw);
    const now = Date.now();

    // Verify session has not expired (< 7 days)
    if (data.timestamp && now - data.timestamp < ONE_WEEK_MS) {
      return data;
    }

    clearClientSession();
    return null;
  } catch (e) {
    clearClientSession();
    return null;
  }
}

export function isClientSessionValid(): boolean {
  return getClientSession() !== null;
}

export function clearClientSession(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    document.cookie = `${COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  } catch (e) {
    // Ignore clear errors
  }
}
